import { ChangePasswordSchemaType, MyProfileSchemaType } from '@/types/auth.types';
import { AuthUser } from '@/types/types';
import { axios } from '@/lib/axios';

import { LoginPayload } from './auth.types';

const PATH = '/api/auth';

export const login = async (payload: LoginPayload) => {
  const response = await axios.post<{ accessToken: string; refreshToken: string; user: AuthUser }>(
    `${PATH}/login`,
    {
      username: payload.username,
      password: payload.password,
      useCookie: true,
    }
  );

  return response.data;
};

export const logout = async () => {
  const response = await axios.post<{ data: []; success: boolean }>(`${PATH}/logout`);
  return response.data;
};

export const getMe = async (): Promise<{ user: AuthUser | null }> => {
  try {
    const response = await axios.get<AuthUser>(`${PATH}/me`);
    return { user: response.data };
  } catch {
    return { user: null };
  }
};

const getMyProfile = async () => {
  const response = await axios.get(`${PATH}/profile`);
  return response.data;
};

const updateMyProfile = async (data: MyProfileSchemaType) => {
  const response = await axios.put(`${PATH}/profile`, data);
  return response.data;
};

const changeMyPassword = async (data: ChangePasswordSchemaType) => {
  const response = await axios.post(`${PATH}/change-password`, data);
  return response.data;
};

const AuthService = {
  login,
  logout,
  getMe,
  getMyProfile,
  updateMyProfile,
  changeMyPassword,
};

export default AuthService;
